 <img
     ngSrc="{{ src }}"
      [width]="width"
      [height]="height"
      [alt]="alt"
      [priority]="priority"
      [ngClass]="['block', imgClass]"
    />